"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const stellarService_1 = require("./stellarService");
const stellar_sdk_1 = require("stellar-sdk");
const axios_1 = __importDefault(require("axios"));
exports.fetchUnlockTransaction = (unlockHash) => __awaiter(void 0, void 0, void 0, function* () {
    const { serviceUrl } = stellarService_1.getConfig();
    const result = yield axios_1.default.post(`${serviceUrl}/unlock_service/get_unlockhash_transaction`, {
        args: { unlockhash: unlockHash },
    });
    //@todo: validation
    const { network } = stellarService_1.getConfig();
    return new stellar_sdk_1.Transaction(result.data.transaction_xdr, network);
});
exports.getLockedBalances = (keyPair) => __awaiter(void 0, void 0, void 0, function* () {
    const { server, currencies } = stellarService_1.getConfig();
    const accounts = server
        .accounts()
        .forSigner(keyPair.publicKey())
        .limit(200);
    const allowedCurrencies = Object.keys(currencies);
    const accountRecord = yield accounts.call();
    const signedAccounts = accountRecord.records
        .filter(a => a.id !== keyPair.publicKey())
        .filter(a => !Object.keys(a.data_attr).includes('tft-vesting'));
    return signedAccounts.map(account => {
        var _a;
        const unlockHashSigner = account.signers.find(s => s.type === 'preauth_tx');
        return {
            keyPair,
            id: account.id,
            balance: account.balances.find(b => b.asset_type !== 'native' &&
                allowedCurrencies.includes(b.asset_code)),
            unlockHash: ((_a = unlockHashSigner) === null || _a === void 0 ? void 0 : _a.key) || null,
        };
    });
});
exports.transferLockedTokens = (keyPair, id, asset_code, amount) => __awaiter(void 0, void 0, void 0, function* () {
    const { server, network, currencies } = stellarService_1.getConfig();
    const account = yield server.loadAccount(keyPair.publicKey());
    const builder = new stellar_sdk_1.TransactionBuilder(account, {
        fee: stellar_sdk_1.BASE_FEE,
        networkPassphrase: network,
    });
    if (amount) {
        builder.addOperation(stellar_sdk_1.Operation.payment({
            destination: keyPair.publicKey(),
            asset: new stellar_sdk_1.Asset(asset_code, currencies[asset_code].issuer),
            amount: amount.toFixed(7),
            source: id,
        }));
    }
    builder.addOperation(stellar_sdk_1.Operation.changeTrust({
        source: id,
        asset: new stellar_sdk_1.Asset(asset_code, currencies[asset_code].issuer),
        limit: '0',
    }));
    builder
        .addOperation(stellar_sdk_1.Operation.accountMerge({
        source: id,
        destination: keyPair.publicKey(),
    }))
        .setTimeout(86400);
    const transaction = builder.build();
    transaction.sign(keyPair);
    console.log(transaction.toXDR());
    try {
        yield server.submitTransaction(transaction);
    }
    catch (e) {
        console.log(e);
        throw Error(`Failed to submit locked transaction ${e} `);
    }
});
//# sourceMappingURL=lockService.js.map